module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921002334_T.2609ed33.jpg";